import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { styled } from 'styled-components';

interface DroppableGroupRowProps {
  groupId: string;
  color: string;
  children: React.ReactNode;
}

const Container = styled.div<{ $color: string; $isOver: boolean }>`
  margin-bottom: 16px;
  background: ${(p) => (p.$isOver ? `${p.$color}20` : `${p.$color}08`)};
  border: 1px solid ${(p) => (p.$isOver ? p.$color : `${p.$color}30`)};
  border-left: 4px solid ${(p) => p.$color};
  border-radius: 8px;
  padding: 10px 14px;
  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s;
  ${(p) => p.$isOver && `box-shadow: inset 0 0 0 2px ${p.$color}40;`}
`;

const DroppableGroupRow: React.FC<DroppableGroupRowProps> = ({ groupId, color, children }) => {
  const { setNodeRef, isOver } = useDroppable({ id: `group::${groupId}` });

  return (
    <Container ref={setNodeRef} $color={color} $isOver={isOver}>
      {children}
    </Container>
  );
};

export default DroppableGroupRow;
